import { PdfMetaData } from "../../../../commons/types/pdf";
import useQuery, { UseQueryOptions } from "../hooks/use-query";
import { getPdfMetadataFromUrl } from "../services/pdf-service/pdf";

const TOPIC = "pdf" as const;
const queryKey = (keys: string[] = []) => [TOPIC, ...keys] as const;

export const useGetPdfMetaDataFromUrl = ({
  url,
  options = {}
}: {
  url: string;
  options?: Omit<Partial<UseQueryOptions<PdfMetaData>>, "queryKey" | "queryFn">;
}) => {
  return useQuery({
    ...options,
    queryKey: queryKey(["getPdfMetaDataFromUrl", url]),
    queryFn: () => getPdfMetadataFromUrl(url)
  });
};
